CSS.insert(`
    ui-overlay { 
        --offset: calc(var(--titlebar-height) + var(--header-height) + var(--banner-height));

        display: block;
        position: absolute;
        left: 0;
        top: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0,0,0,0); 
        -webkit-backface-visibility: hidden; 
    }
    ui-overlay:focus { 
        outline: none; 
    }

    ui-window[data-stack="0"] + ui-overlay,
    .widget.context + ui-overlay { 
        background: var(--overlay-backdrop);
    }

    body.overlay ui-window[data-stack="0"] + ui-overlay,
    body.overlay .widget.context + ui-overlay,
    body.overlay ui-sidebar.visible + ui-overlay { 
        background: linear-gradient(
            to bottom, 
            transparent var(--header-height), 
            var(--overlay-backdrop) var(--header-height)
        );
    }
        
    body.overlay.Capacitor ui-window[data-stack="0"] + ui-overlay,
    body.overlay.Capacitor .widget.context + ui-overlay,
    body.overlay.Capacitor ui-sidebar.visible + ui-overlay { 
        background: linear-gradient(
            to bottom, 
            transparent var(--header-height), 
            var(--overlay-backdrop) var(--header-height), 
            calc(100% - var(--footer-height)), 
            transparent calc(100% - var(--footer-height))
        );
    }

    body.overlay ui-window[data-stack="0"] + ui-overlay[data-stack="1"],
    body.overlay .widget.context + ui-overlay[data-stack="1"] { 
        background: none !important;
    }

`);
var Overlay = Class.create();
Overlay.count = 0;
Overlay.prototype = {
  initialize: function (options) {
    this.options = Object.assign({
      animate: true,
      onHide: null,
      zIndex: 999,
      owner: null
    }, options || {});
    this.destroyed = false;

    // Overlay with opacity
    this.overlay = document.createElement("ui-overlay");
    this.overlay.tabIndex = -1;
    this.overlay.dataset.stack = Overlay.count;
    this.overlay.style.zIndex = this.options.zIndex;
    this.overlay.addEventListener('focus', this.onFocus.bind(this));
    this.overlay.hide();
    if (this.options.owner) {
      this.options.owner.insertAdjacentElement('afterend', this.overlay);
    } else {
      document.body.appendChild(this.overlay);
    }
    Overlay.count++;
    window.setTimeout(() => {
      if (System.Type.Mobile && !System.Type.Tablet) {
        this.overlay.style.height = `${document.documentElement.clientHeight}px`;
        this.overlay.style.width = `1000px`;
      }
      this.overlay.show();
      if (Overlay.count == 1) {
        if (typeof Application != "undefined" && Application.enableOverlay) {
          Application.enableOverlay();
        } else {
          document.body.classList.add('overlay');
        }
      }
    }, 0);
    this.startInspection();
    window.setTimeout(() => {
      if (this.options.onHide) {
        this.overlay.observe('click', this.options.onHide);
      }
    }, 300);
  },
  resize: function () {
    var size = document.body.getBoundingClientRect();
    this.overlay.style.height = size.height + 'px';
  },
  destroy: function () {
    if (this.destroyed) {
      return;
    }
    this.destroyed = true;
    this.stopInspection();
    if (this.overlay.parentNode) this.overlay.remove();
    if (Overlay.count > 0) {
      Overlay.count--;
    }
    if (Overlay.count == 0) {
      if (typeof Application != "undefined" && Application.disableOverlay) {
        Application.disableOverlay();
      } else {
        document.body.classList.remove('overlay');
      }
    }
  },
  startInspection: function () {
    window.addEventListener('resize', this.viewPortHasResized.bind(this));
    window.addEventListener('orientationchange', this.viewPortHasRotated.bind(this));
  },
  stopInspection: function () {
    window.removeEventListener('resize', this.viewPortHasResized.bind(this));
    window.removeEventListener('orientationchange', this.viewPortHasRotated.bind(this));
  },
  viewPortHasResized: function () {
    this.resize();
  },
  viewPortHasRotated: function () {
    this.resize();
  },
  onFocus: function () {
    let window = Window.list[Window.list.length - 1];
    if (window) {
      window.focus();
    }
  },
  set onHide(value) {
    if (this.options.onHide) {
      this.overlay.stopObserving('click', this.options.onHide);
    }
    this.options.onHide = value;
    if (this.options.onHide) {
      this.overlay.observe('click', this.options.onHide);
    }
  }
};
//# sourceMappingURL=overlay.js.map
